import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { consumePasswordResetToken } from './app/auth/resetToken';
import { initializeTheme } from './app/theme/themeState';
import './app/styles.css';

initializeTheme();
const initialPasswordResetToken = consumePasswordResetToken();

const rootElement = document.getElementById('root');

if (rootElement === null) {
  throw new Error('Flow Wizard could not find its root element.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App initialPasswordResetToken={initialPasswordResetToken} />
  </StrictMode>,
);
